/**
 * 全局axios拦截器配置
 * 为所有直接使用axios的地方添加统一的错误处理
 */
import axios from 'axios'
import { clearAuthCookies } from './auth'
import { accountReasonOf, handleAccountBlocked, isAccountBlockedReason } from './accountSession'
import { applyH5CredentialHeader } from './h5Credential'

// 响应拦截器 - 统一处理401错误
axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    // 账号停用/删除：记录具体原因，重置用户状态并返回登录页
    const blockedReason = accountReasonOf(error.response)
    if (isAccountBlockedReason(blockedReason)) {
      console.error('🔒 全局拦截器 - 账号状态受限:', {
        url: error.config?.url,
        method: error.config?.method,
        reason: blockedReason,
      })
      handleAccountBlocked(blockedReason as string)
      return Promise.reject(error)
    }

    if (error.response?.status === 403) {
      // 403 表示没有权限访问
      console.error('🟠 全局拦截器 - 无权限(403):', {
        url: error.config?.url,
        method: error.config?.method,
        error: error.response?.data,
      })
      console.error('无权限')
    } else if (error.response?.status === 401) {
      // 401表示后端JWT验证失败
      console.error('🔴 全局拦截器 - 后端验证失败(401):', {
        url: error.config?.url,
        method: error.config?.method,
        error: error.response?.data
      })
      
      // 检查是否已经在登录页，避免重复跳转
      const currentPath = window.location.pathname
      if (currentPath === '/login' || currentPath === '/web/login') {
        console.log('⚠️ 已在登录页，忽略401错误')
        return Promise.reject(error)
      }
      
      // 检查是否正在跳转中，避免重复处理
      if (window.location.href.includes('/login')) {
        console.log('⚠️ 正在跳转登录页，忽略401错误')
        return Promise.reject(error)
      }
      
      // JWT token无效或过期，清除所有认证相关的cookie
      console.log('🔐 JWT验证失败，清除所有认证信息')
      clearAuthCookies()
      
      console.error('登录已过期，请重新登录')
      
      // 延迟跳转登录页
      setTimeout(() => {
        window.location.href = '/login'
      }, 1500)
    }
    return Promise.reject(error)
  }
)

// 请求拦截器 - 自动携带cookie
axios.interceptors.request.use(
  (config) => {
    // 确保所有axios请求都携带credentials（cookie）
    config.withCredentials = true
    // H5 业务请求自动透传加密凭据（来源：页面 URL 的 encrypt 参数）
    applyH5CredentialHeader(config)
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

console.log('✅ 全局axios拦截器已配置')

